import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    maxWidth: 376,
    minHeight: 346,

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: SPACES.m,
    padding: SPACES.xxxxxl,
  },
  form: {
    minHeight: 160,
    position: 'relative',

    flex: 1,
    gap: SPACES.m,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  languagesLabel: {
    color: '#3faca8',
    fontWeight: 400,
    display: 'block',
    width: '100%',
    '&&': {
      marginTop: SPACES.s,
      marginBottom: SPACES.xxxs,
    },
  },
  languagesList: {
    marginTop: '20px',
    maxHeight: '225px',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
}))
